import { Box, Card, Link, Typography } from '@mui/material';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { Business_Profile_Enum } from '@kheops/graphql';
import { isRichTextEmpty } from '../common/utils/common.utils';
import Sheet from '../common/components/Sheet';
import ExpandableText from '../common/components/ExpandableText';
import { CompanyInfo } from './companyInfo/CompanyInfoCard';

export interface CompanyDescriptionProps {
  company: CompanyInfo;
}

export default function CompanyDescription({ company }: CompanyDescriptionProps): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {company.business_profile === Business_Profile_Enum.Supplier && !!company.description && !isRichTextEmpty(company.description) && (
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'surfaceContainerLow.main',
            position: 'relative',
            p: 2,
            pb: 0,
            borderRadius: 3,
            gap: 0.5,
          }}
        >
          <Typography variant="titleSmall">
            {t('common:about')}
          </Typography>
          <Box
            sx={{
              '.Kheops-expandableText-toggle': {
                display: 'none',
              },
              mb:'auto',
            }}
          >
            <ExpandableText
              text={company.description}
              isDangerousText
              lineClampThreshold={3}
              color="onSurfaceVariant.main"
              variant="bodySmall"
            />
          </Box>
          <Box
            sx={{
              backgroundColor: 'surfaceContainerLow.main',
              width: 'calc(100% - 32px)',              
              pb: 2,
              pt: 1,
            }}
          >
            <Link
              sx={{ display: 'flex', alignItems: 'center', color: 'onSurfaceVariant.main', cursor: 'pointer' }}
              onClick={() => setDrawerOpen(true)}
            >
              <KeyboardArrowRightOutlinedIcon sx={{ fontSize: '1.125rem', mr: 0.5 }} />
              <Typography variant="labelSmall">
                {t('common:learn_more_about')}
              </Typography>
            </Link>
          </Box>
          <Sheet
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            title={t('common:description')}
            width={356}
          >
            <Typography
              variant="bodyMedium"
              sx={{
                px: 1,
              }}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(company.description) }}
            />
          </Sheet>
        </Card>
      )}
    </>
  );
}
